import React from "react";
import FirstSection from "./FirstSection";
import SecondSection from "./SecondSection";
import SavingThirdSection from "./ThirdSection";
import EmbeddedBanking from "./EmbeddedBanking";
import SecureYourMoney from "./SecureYourMoney";
import ProtectFromDepreciation from "./ProtectFromDepreciation";
import FreeAccountSection from "./FreeAccountSection";
import StabelReturn from "./StableReturn";
import WebsiteLayout from "./../../Components/Navbar/WebsiteLayout";
import BorderlessMoneyBanner from "./../../Components/BorderlessMoneyBanner";
import TrustedPartner from "./TrustedPartner";

function LandingPage() {
  return (
    <WebsiteLayout>
      <BorderlessMoneyBanner />

      <div className="w-full mt-[63px] lg:mt-[80px] lg:min-h-[calc(100dvh-136px)]  overflow-auto ">
        <FirstSection />
        <hr className="border-hrsavings border-[1px]" />
        <TrustedPartner />
        <SecondSection />
        <SavingThirdSection />
        <hr className="border-hrsavings border-[1px]" />
        <ProtectFromDepreciation />
        <FreeAccountSection />
        <div className=" mt-[45px] md:my-[75px]">
          <h1 className="font-IvyJournal font-[600] text-[28px] md:text-[52px] md:leading-[65px] text-blackish  w-[85%] md:w-full md:max-w-lg text-center mx-auto">
            Make your money work for you
          </h1>
        </div>
        <StabelReturn />
        <SecureYourMoney />
        <EmbeddedBanking />
      </div>
    </WebsiteLayout>
  );
}

export default LandingPage;
